<template>
  <div class="mine">
    <img :src="img_url" alt="">
  </div>
</template>
<script>
import { getRadarImg, getUserInfo } from '@/api/edu'
export default {
  data() {
    return {
      id: this.$route.query.id,
      uid: this.$route.query.uid,
      img_url: ''
    }
  },
  mounted() {
    this.getRadarImg()
    // this.getUserInfo()
  },
  methods: {
    getRadarImg() {
      const info = {
        id: this.id
      }
      getRadarImg(info).then(res => {
        console.log(res, 'res')
        if (res.errNo == 0) {
          this.img_url = res.result.img_url || ''
          // 设置title标题
          // const my_title = document.getElementsByTagName('title')[0]
          // my_title.innerHTML = res.result.title
          // document.discription = res.result.discription
          // // 设置关键词
          // // const my_keys = document.getElementsByName('keywords')[0]
          // // my_keys.content = res.result.result.words
          // // 设置描述
          // const my_description = document.getElementsByName('description')[0]
          // console.log(my_description,'my_description')
          // my_description.content = res.result.discription
          console.log(document.title, 'title')
        }
      }).then(res => {
        var url = window.location.origin + `/edu/prod-api/home/radar/getUserInfo?id=${this.id}&from_uid=${this.uid}`
        console.log(url, 'url')
        // window.open(url)
        window.location.href = url
      })
    }
    // getUserInfo(){
    //   const info = {
    //     id: this.id,
    //     from_uid: this.uid
    //   }
    //   getUserInfo(info).then(res=>{
    //     console.log(res,'res')
    //   })
    // }
  }
}
</script>
<style lang="scss" scoped>
.mine{
  img{
    display: block;
    max-width: 100%;
    margin: 100px auto 0;
  }
}
</style>
